'use strict';

import _      from 'lodash';

const defaultValues = {
  poolStyleId: 'Bracket Picks',
  poolStyleConfig: {
    value: 5,
    field: []
  },
  scoringMethodId: 'Assign Values',
  scoringMethodConfig: {
    cutoffHash: {
      cutoffs: [
        {cutoff: 1, value: 10},
        {cutoff: 3, value: 8},
        {cutoff: 7, value: 6},
        {cutoff: 15, value: 4},
        {cutoff: 25, value: 2}
      ],
      default: 1
    },
    options: [
      {
        name: 'Low round',
        value: 1
      },
      {
        name: 'All picks make cut',
        value: 3
      }
    ]
  }
};

export default {
  namespaced: true,
  state: {
    pool:               {}
  },
  mutations: {
    setPool(state, pool) {
      let oldPool = {...state.pool};
      for (let k in pool) {
        _.set(oldPool, k, pool[k]);
      }
      state.pool = {...oldPool};
    },
    resetPool(state) {
      state.pool = {
        id:                    null,
        tournament_id:         null,
        name:                  '',
        private:               false,
        description:           '',
        pool_style_id:         '',
        pool_style_config:     {},
        scoring_method_id:     '',
        scoring_method_config: {},
        adjusting_participations: []
      };
    },
    resetPoolStyle(state) {
      state.pool.pool_style_id = defaultValues.poolStyleId;
      state.pool.pool_style_config = {...defaultValues.poolStyleConfig};
    },
    resetScoringMethod(state) {
      state.pool.scoring_method_id = defaultValues.scoringMethodId;
      state.pool.scoring_method_config = {...defaultValues.scoringMethodConfig};
    },
    setValue(state, [key, value]) {
      let oldPool = {...state.pool};
      _.set(oldPool, key, value);
      state.pool = {...oldPool};
    },
    pushArrayValue(state, [key, value]) {
      _.get(state.pool, key).push(value);
    },
    unshiftArrayValue(state, [key, value]) {
      _.get(state.pool, key).unshift(value);
    },
    removeArrayValueByIndex(state, [key, value]) {
      let oldPool = {...state.pool};
      _.set(oldPool, key, _.get(state.pool, key).filter((item,index) => index !== value));
      state.pool = {...oldPool};
    }
  },
  actions: {
    setPool({commit}, pool) {
      // Add adjusting_participations empty array so no participation changes are made
      commit('setPool', {...pool, adjusting_participations: []});
    },
    setPoolTemplate({dispatch}, pool) {
      dispatch(
        'setPool', 
        _.pick(pool, ['private', 'description', 'pool_style_id', 'pool_style_config.value', 'scoring_method_id', 'scoring_method_config'])
      );
    },
    resetPool({commit, dispatch}) {
      commit('resetPool');
      dispatch('resetPoolStyle');
      dispatch('resetScoringMethod');
    },
    resetPoolStyle({commit}) {
      commit('resetPoolStyle');
    },
    resetScoringMethod({commit}) {
      commit('resetScoringMethod');
    },
    setTournamentId({commit}, id) {
      commit('setValue', ['tournament_id', id]);
    },
    setName({commit}, name) {
      commit('setValue', ['name', name]);
    },
    setDescription({commit}, description) {
      commit('setValue', ['description', description]);
    },
    setPrivate({commit}, priv) {
      commit('setValue', ['private', priv]);
    },
    setPoolStyleId({commit}, id) {
      commit('setValue', ['pool_style_id', id]);
      commit('setValue', ['pool_style_config', {...defaultValues.poolStyleConfig}]);
    },
    setPoolStyleConfigValue({commit}, value) {
      commit('setValue', ['pool_style_config.value', value]);
    },
    setPoolStyleConfigField({commit}, value) {
      commit('setValue', ['pool_style_config.field', value]);
    },
    setScoringMethodId({commit}, id) {
      commit('setValue', ['scoring_method_id', id]);
      commit('setValue', ['scoring_method_config', {...defaultValues.scoringMethodConfig}]);
    },
    setScoringMethodConfigCutoffHashCutoffCutoff({commit}, [index, value]) {
      commit('setValue', [`scoring_method_config.cutoffHash.cutoffs[${index}].cutoff`, value]);
    },
    setScoringMethodConfigCutoffHashCutoffValue({commit}, [index, value]) {
      commit('setValue', [`scoring_method_config.cutoffHash.cutoffs[${index}].value`, value]);
    },
    addScoringMethodConfigCutoffHashCutoff({commit}, value) {
      commit('pushArrayValue', ['scoring_method_config.cutoffHash.cutoffs', value]);
    },
    removeScoringMethodConfigCutoffHashCutoff({commit}, value) {
      commit('removeArrayValueByIndex', ['scoring_method_config.cutoffHash.cutoffs', value]);
    },
    setScoringMethodConfigCutoffHashDefault({commit}, value) {
      commit('setValue', ['scoring_method_config.cutoffHash.default', value]);
    },
    removeScoringMethodConfigOption({commit, state}, value) {
      commit('removeArrayValueByIndex',
        [
          'scoring_method_config.options',
          state.pool.scoring_method_config.options.findIndex(option => option.name === value)
        ]
      );
    },
    addScoringMethodConfigOption({commit}, value) {
      commit('pushArrayValue', ['scoring_method_config.options', value]);
    },
    setScoringMethodConfigOptionValue({commit, state}, [name, value]) {
      const index = state.pool.scoring_method_config.options.findIndex(option => option.name === name);
      commit('setValue',
        [
          `scoring_method_config.options[${index}].value`,
          value
        ]
      );
    },
    addAdjustingParticipation({commit, state}, {email, name, action}) {
      if (!state.pool.adjusting_participations.find(({email: foundEmail}) => foundEmail === email)) {
        commit('unshiftArrayValue', ['adjusting_participations', {action, email, name}]);
      }
    },
    removeAdjustingParticipation({commit}, index) {
      commit('removeArrayValueByIndex', ['adjusting_participations', index]);
    }
  },
  getters: {
    pool(state) {
      return state.pool;
    },
    isDefaultConfig(state) {
      return _.isEqual(_.get(state, ['pool', 'pool_style_id']), defaultValues.poolStyleId) &&
        // Ignore "field" because it can be set without pool owner's action
        _.isEqual(_.omit(_.get(state, ['pool', 'pool_style_config']), ['field']), _.omit(defaultValues.poolStyleConfig, ['field'])) &&
        _.isEqual(_.get(state, ['pool', 'scoring_method_id']), defaultValues.scoringMethodId) &&
        _.isEqual(_.get(state, ['pool', 'scoring_method_config']), defaultValues.scoringMethodConfig);
    },
    isPoolNew(state) {
      return state.pool && !state.pool.id;
    }
  }
};
